/**
 * Age Gate Web Component
 * Simple age verification modal
 */
class AgeGate extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('[data-age-gate-dialog]');
    this.cookieName = this.dataset.cookieName || 'age-gate-verified';
    this.cookieDays = 365; // 1 year

    this.init();
  }

  init() {
    if (this.hasValidCookie()) {
      return;
    }

    this.setupEventListeners();
    this.showGate();
  }

  setupEventListeners() {
    const acceptBtn = this.querySelector('[data-age-gate-accept]');
    const cancelBtn = this.querySelector('[data-age-gate-cancel]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', () => this.handleAccept());
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => this.handleCancel());
    }

    // Prevent closing dialog with ESC key
    this.dialog.addEventListener('cancel', (e) => {
      e.preventDefault();
    });
  }

  showGate() {
    this.classList.add('is-active');
    this.dialog.showModal();
    document.body.style.overflow = 'hidden';
  }

  handleAccept() {
    this.setCookie();
    this.hideGate();
  }

  handleCancel() {
    // Go back to previous page
    window.history.back();
  }

  hideGate() {
    this.dialog.close();
    this.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  setCookie() {
    const date = new Date();
    date.setTime(date.getTime() + (this.cookieDays * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${this.cookieName}=verified;${expires};path=/;SameSite=Lax`;
  }

  hasValidCookie() {
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === this.cookieName && value === 'verified') {
        return true;
      }
    }
    return false;
  }
}

// Register the custom element
if (typeof customElements !== 'undefined') {
  customElements.define('age-gate', AgeGate);
}

// Expose function to clear age gate cookie
window._clearAgeGate = function(cookieName = 'age-gate-verified') {
  document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;SameSite=Lax`;
  console.log(`Age gate cookie "${cookieName}" cleared`);
}
